// InvoicesTable.jsx
import React from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import "./Invoices.css";
import "./InvoicesTable.css";
import moment from "moment";
import NumberFormat from "react-number-format";
import { LuTrendingUp, LuTrendingDown, LuMinus } from "react-icons/lu";

import {
  translateStatus,
  PaymentMethod,
  DeliveryType,
  SaleType,
} from "../../utils/pagarme";
import { calcRealProfit, statusTone } from "./salesMetrics";
import InvoiceActionsMenu from "./InvoiceActionsMenu";

const Money = ({ value }) => (
  <NumberFormat
    value={value}
    displayType={"text"}
    thousandSeparator="."
    prefix={"R$ "}
    decimalScale={2}
    fixedDecimalScale={true}
    decimalSeparator=","
  />
);

const InvoicesTable = ({
  data = [],
  productCosts = {},
  onView,
  onEdit,
  onEditOrderManually,
  onDelete,
  onPayment,
}) => {
  const columns = [
    {
      sortable: false,
      Header: "Pedido",
      accessor: "idTransaction",
      minWidth: 110,
      Cell: ({ original }) => (
        <span className="invoice-code">{original.idTransaction}</span>
      ),
    },
    {
      Header: "Canal",
      accessor: "description",
      minWidth: 150,
      Cell: ({ original }) => SaleType(original.description),
    },
    {
      minWidth: 160,
      Header: "Cliente",
      accessor: "customer.name",
    },
    {
      Header: "Data",
      accessor: "dataTransaction",
      minWidth: 130,
      Cell: ({ original }) =>
        moment(original.dataTransaction).format("DD/MM/YYYY HH:mm"),
    },
    {
      Header: "Status",
      accessor: "status",
      minWidth: 130,
      Cell: ({ original }) => (
        <span
          className={`invoice-status invoice-status--${statusTone(original.status)}`}
        >
          {translateStatus(original.status)}
        </span>
      ),
    },
    {
      Header: "Pagamento",
      accessor: "paymentMethod",
      minWidth: 120,
      Cell: ({ original }) => PaymentMethod(original.paymentMethod),
    },
    {
      Header: "Total",
      accessor: "amount",
      minWidth: 100,
      Cell: ({ original }) => <Money value={original.amount / 100} />,
    },
    {
      Header: "Lucro real",
      accessor: "profitCalc",
      sortable: false,
      minWidth: 130,
      Cell: ({ original }) => {
        const result = calcRealProfit(original, productCosts);
        if (!result) return <span className="invoice-profit-muted">—</span>;

        const { profit, margin, partial } = result;
        const tone =
          Math.abs(profit) < 0.01
            ? "neutral"
            : profit > 0
              ? "positive"
              : "negative";
        const Icon =
          tone === "positive"
            ? LuTrendingUp
            : tone === "negative"
              ? LuTrendingDown
              : LuMinus;

        return (
          <span
            className={`invoice-profit invoice-profit--${tone}`}
            title={
              partial
                ? "Algum item do pedido não tem custo cadastrado — valor parcial"
                : undefined
            }
          >
            <Icon size={13} />
            <Money value={profit} />
            {margin !== null && <small> ({margin.toFixed(0)}%)</small>}
            {partial && <sup>*</sup>}
          </span>
        );
      },
    },
    {
      Header: "Tipo entrega",
      accessor: "tracking.type",
      minWidth: 100,
      Cell: ({ original }) => DeliveryType(original.tracking?.type),
    },
    {
      Header: "Entrega",
      accessor: "tracking.status",
      minWidth: 120,
    },
    {
      sortable: false,
      Header: "",
      accessor: "action",
      width: 56,
      Cell: ({ original }) => (
        <InvoiceActionsMenu
          order={original}
          onView={onView}
          onEdit={onEdit}
          onEditOrderManually={onEditOrderManually}
          onDelete={onDelete}
          onPayment={onPayment}
        />
      ),
    },
  ];

  return (
    <section className="sales-card sales-orders">
      <header className="sales-card__header">
        <h2 className="sales-card__title">Pedidos</h2>
        <span className="sales-card__meta">
          {data.length} {data.length === 1 ? "pedido" : "pedidos"}
        </span>
      </header>

      <ReactTable
        data={Array.isArray(data) ? data : []}
        columns={columns}
        defaultPageSize={10}
        minRows={1}
        previousText="Anterior"
        nextText="Próxima"
        pageText="Página"
        ofText="de"
        rowsText="linhas"
        noDataText="Nenhum pedido encontrado"
        className="invoices-table sales-orders__table"
      />
    </section>
  );
};

export default InvoicesTable;
